<template>
  <div class="ui-body">
    <dl>
      <dt>条形图</dt>
      <dd>
        <ve-bar :data="data" :settings="barSettings" :legend="legend" :xAxis="xAxis" :yAxis="yAxis"></ve-bar>
      </dd>
    </dl>
    <dl>
      <dt>柱状图</dt>
      <dd>
        <ve-histogram
          :data="data"
          :settings="histogramSettings"
          :legend="legend"
          :xAxis="xAxis"
          :yAxis="yAxis"
        ></ve-histogram>
      </dd>
    </dl>
    <dl>
      <dt>折线图</dt>
      <dd>
        <ve-line
          :data="data"
          :settings="lineSettings"
          :legend="legend"
          :xAxis="xAxis"
          :yAxis="yAxis"
          :tooltipFormatter="tooltipFormatter"
        ></ve-line>
      </dd>
    </dl>
    <dl>
      <dt>饼图</dt>
      <dd>
        <ve-pie :data="dataSimple" :settings="pieSettings" :legend="legend2"></ve-pie>
      </dd>
    </dl>
    <dl>
      <dt>环形图</dt>
      <dd>
        <ve-ring :data="dataSimple" :settings="ringSettings" :legend="legend2"></ve-ring>
      </dd>
    </dl>
    <dl>
      <dt>表格</dt>
      <dd>
        <ve-table :data="dataSimple" :settings="ringSettings" :legend="legend2"></ve-table>
      </dd>
    </dl>
  </div>
</template>

<script>
/* eslint-disable */
import echarts from "echarts";
export default {
  name: "demo",
  data() {
    return {
      data: {
        columns: ["日期", "名称"],
        rows: [
          { 日期: "1954 年", 名称: 123 },
          { 日期: "1955 年", 名称: 1223 },
          { 日期: "1956 年", 名称: 2123 },
          { 日期: "1957 年", 名称: 4123 },
          { 日期: "1958 年", 名称: 3123 },
          { 日期: "1959 年", 名称: 7123 }
        ]
      },
      dataSimple: {
        columns: ["日期", "名称"],
        rows: [{ 日期: "1954 年", 名称: 523 }, { 日期: "1955 年", 名称: 1223 }]
      },
      barSettings: {
        itemStyle: {
          normal: {
            // barBorderRadius: [0, 6, 6, 0],
            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
              { offset: 0, color: "#6C30F3" },
              { offset: 1, color: "#188EFF" }
            ])
          }
        }
      },
      histogramSettings: {
        itemStyle: {
          normal: {
            // barBorderRadius: [6, 6, 0, 0],
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "#188EFF" },
              { offset: 1, color: "#6C30F3" }
            ])
          }
        }
      },
      lineSettings: {
        itemStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "#188EFF" },
              { offset: 1, color: "#6C30F3" }
            ])
          }
        }
      },
      pieSettings: {
        label: {
          normal: {
            textStyle: {
              color: "rgba(255, 255, 255, 0.3)"
            }
          }
        },
        labelLine: {
          normal: {
            lineStyle: {
              color: "rgba(255, 255, 255, 0.3)"
            },
            smooth: 0.2,
            length: 10,
            length2: 20
          }
        }
      },
      ringSettings: {
        label: {
          normal: {
            textStyle: {
              color: "rgba(255, 255, 255, 0.3)"
            }
          }
        },
        labelLine: {
          normal: {
            lineStyle: {
              color: "rgba(255, 255, 255, 0.3)"
            },
            smooth: 0.2,
            length: 10,
            length2: 20
          }
        }
      },
      settings: {},
      xAxis: {
        axisLabel: {
          color: "#666"
        },
        splitLine: {
          show: false,
          lineStyle: {
            color: "rgba(255,255,255,0.2)",
            type: "solid"
          }
        }
      },
      yAxis: {
        axisLabel: {
          color: "#666"
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "rgba(255,255,255,0.2)",
            type: "solid"
          }
        }
      },
      legend: {
        show: false
      },
      legend2: {
        bottom: "14%"
      },
      tooltipFormatter: function(e) {
        debugger;
      }
    };
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Demo.vue